package com.eladfinish.bible.contest

import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.`internal`.SupportedLocale
import dev.icerock.moko.resources.`internal`.SupportedLocales
import dev.icerock.moko.resources.provider.RemoteJsStringLoader
import kotlin.String
import kotlin.collections.List

private val fallbackFileUrl: String =
    js("require(\"./localization/comeladfinishbiblecontest_stringsJson.json\")") as String

private val supportedLocales: SupportedLocales = SupportedLocales(listOf(
    SupportedLocale("de",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_de.json\")") as String),
    SupportedLocale("en",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_en.json\")") as String),
    SupportedLocale("es",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_es.json\")") as String),
    SupportedLocale("fr",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_fr.json\")") as String),
    SupportedLocale("ru",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_ru.json\")") as String),
    ))

private val stringsLoader: RemoteJsStringLoader = RemoteJsStringLoader.Impl(supportedLocales =
    supportedLocales, fallbackFileUri = fallbackFileUrl)

internal object CommonMainStrings11 {
  internal val show_verse_letter: StringResource by lazy { init_show_verse_letter() }

  internal val show_words_partially: StringResource by lazy { init_show_words_partially() }

  internal val shuffle_verses: StringResource by lazy { init_shuffle_verses() }

  internal val signs: StringResource by lazy { init_signs() }

  internal val single_word: StringResource by lazy { init_single_word() }

  internal val size_huge: StringResource by lazy { init_size_huge() }

  internal val size_large: StringResource by lazy { init_size_large() }

  internal val size_medium: StringResource by lazy { init_size_medium() }

  internal val size_medium_value: StringResource by lazy { init_size_medium_value() }

  internal val size_small: StringResource by lazy { init_size_small() }

  internal val size_tiny: StringResource by lazy { init_size_tiny() }

  internal val skip: StringResource by lazy { init_skip() }

  internal val so_far_found: StringResource by lazy { init_so_far_found() }

  internal val something_went_wrong: StringResource by lazy { init_something_went_wrong() }

  internal val sort_results: StringResource by lazy { init_sort_results() }

  internal val sortable: StringResource by lazy { init_sortable() }

  internal val sounds: StringResource by lazy { init_sounds() }

  internal val spaces_between_blanks: StringResource by lazy { init_spaces_between_blanks() }

  internal val stats: StringResource by lazy { init_stats() }

  internal val str_bookmark: StringResource by lazy { init_str_bookmark() }

  internal val str_questions: StringResource by lazy { init_str_questions() }

  internal val str_seconds: StringResource by lazy { init_str_seconds() }

  internal val str_solution: StringResource by lazy { init_str_solution() }

  internal val str_source: StringResource by lazy { init_str_source() }

  internal val str_title: StringResource by lazy { init_str_title() }

  internal val subscription: StringResource by lazy { init_subscription() }

  internal val support_ad_dialog_content: StringResource by lazy { init_support_ad_dialog_content()
      }

  internal val supporting_the_app: StringResource by lazy { init_supporting_the_app() }

  internal val taanit_tzibur: StringResource by lazy { init_taanit_tzibur() }

  internal val tab_bible: StringResource by lazy { init_tab_bible() }

  internal val tab_chumash: StringResource by lazy { init_tab_chumash() }

  internal val tab_misc: StringResource by lazy { init_tab_misc() }

  internal val tab_sedarim: StringResource by lazy { init_tab_sedarim() }

  internal val table_of_contents: StringResource by lazy { init_table_of_contents() }

  internal val teamim: StringResource by lazy { init_teamim() }

  internal val tehilim: StringResource by lazy { init_tehilim() }

  internal val tehilim119: StringResource by lazy { init_tehilim119() }

  internal val telegram_channel: StringResource by lazy { init_telegram_channel() }

  internal val tell_a_friend: StringResource by lazy { init_tell_a_friend() }

  internal val text_copy: StringResource by lazy { init_text_copy() }

  internal val text_only_qri: StringResource by lazy { init_text_only_qri() }

  internal val text_with_nikud: StringResource by lazy { init_text_with_nikud() }

  internal val text_with_teamim: StringResource by lazy { init_text_with_teamim() }

  internal val thanks_for_purchase: StringResource by lazy { init_thanks_for_purchase() }

  internal val thanks_for_support: StringResource by lazy { init_thanks_for_support() }

  internal val thanks_for_support_biblical: StringResource by lazy {
      init_thanks_for_support_biblical() }

  internal val tikun_korim: StringResource by lazy { init_tikun_korim() }

  internal val tiqun_haklali: StringResource by lazy { init_tiqun_haklali() }

  internal val tiqun_haklali_ending: StringResource by lazy { init_tiqun_haklali_ending() }

  internal val tiqun_haklali_intro: StringResource by lazy { init_tiqun_haklali_intro() }

  internal fun values(): List<StringResource> = listOf(show_verse_letter, show_words_partially,
      shuffle_verses, signs, single_word, size_huge, size_large, size_medium, size_medium_value,
      size_small, size_tiny, skip, so_far_found, something_went_wrong, sort_results, sortable,
      sounds, spaces_between_blanks, stats, str_bookmark, str_questions, str_seconds, str_solution,
      str_source, str_title, subscription, support_ad_dialog_content, supporting_the_app,
      taanit_tzibur, tab_bible, tab_chumash, tab_misc, tab_sedarim, table_of_contents, teamim,
      tehilim, tehilim119, telegram_channel, tell_a_friend, text_copy, text_only_qri,
      text_with_nikud, text_with_teamim, thanks_for_purchase, thanks_for_support,
      thanks_for_support_biblical, tikun_korim, tiqun_haklali, tiqun_haklali_ending,
      tiqun_haklali_intro)
}

private fun init_show_verse_letter(): StringResource = StringResource(key = "show_verse_letter",
    loader = stringsLoader)

private fun init_show_words_partially(): StringResource = StringResource(key =
    "show_words_partially", loader = stringsLoader)

private fun init_shuffle_verses(): StringResource = StringResource(key = "shuffle_verses", loader =
    stringsLoader)

private fun init_signs(): StringResource = StringResource(key = "signs", loader = stringsLoader)

private fun init_single_word(): StringResource = StringResource(key = "single_word", loader =
    stringsLoader)

private fun init_size_huge(): StringResource = StringResource(key = "size_huge", loader =
    stringsLoader)

private fun init_size_large(): StringResource = StringResource(key = "size_large", loader =
    stringsLoader)

private fun init_size_medium(): StringResource = StringResource(key = "size_medium", loader =
    stringsLoader)

private fun init_size_medium_value(): StringResource = StringResource(key = "size_medium_value",
    loader = stringsLoader)

private fun init_size_small(): StringResource = StringResource(key = "size_small", loader =
    stringsLoader)

private fun init_size_tiny(): StringResource = StringResource(key = "size_tiny", loader =
    stringsLoader)

private fun init_skip(): StringResource = StringResource(key = "skip", loader = stringsLoader)

private fun init_so_far_found(): StringResource = StringResource(key = "so_far_found", loader =
    stringsLoader)

private fun init_something_went_wrong(): StringResource = StringResource(key =
    "something_went_wrong", loader = stringsLoader)

private fun init_sort_results(): StringResource = StringResource(key = "sort_results", loader =
    stringsLoader)

private fun init_sortable(): StringResource = StringResource(key = "sortable", loader =
    stringsLoader)

private fun init_sounds(): StringResource = StringResource(key = "sounds", loader = stringsLoader)

private fun init_spaces_between_blanks(): StringResource = StringResource(key =
    "spaces_between_blanks", loader = stringsLoader)

private fun init_stats(): StringResource = StringResource(key = "stats", loader = stringsLoader)

private fun init_str_bookmark(): StringResource = StringResource(key = "str_bookmark", loader =
    stringsLoader)

private fun init_str_questions(): StringResource = StringResource(key = "str_questions", loader =
    stringsLoader)

private fun init_str_seconds(): StringResource = StringResource(key = "str_seconds", loader =
    stringsLoader)

private fun init_str_solution(): StringResource = StringResource(key = "str_solution", loader =
    stringsLoader)

private fun init_str_source(): StringResource = StringResource(key = "str_source", loader =
    stringsLoader)

private fun init_str_title(): StringResource = StringResource(key = "str_title", loader =
    stringsLoader)

private fun init_subscription(): StringResource = StringResource(key = "subscription", loader =
    stringsLoader)

private fun init_support_ad_dialog_content(): StringResource = StringResource(key =
    "support_ad_dialog_content", loader = stringsLoader)

private fun init_supporting_the_app(): StringResource = StringResource(key = "supporting_the_app",
    loader = stringsLoader)

private fun init_taanit_tzibur(): StringResource = StringResource(key = "taanit_tzibur", loader =
    stringsLoader)

private fun init_tab_bible(): StringResource = StringResource(key = "tab_bible", loader =
    stringsLoader)

private fun init_tab_chumash(): StringResource = StringResource(key = "tab_chumash", loader =
    stringsLoader)

private fun init_tab_misc(): StringResource = StringResource(key = "tab_misc", loader =
    stringsLoader)

private fun init_tab_sedarim(): StringResource = StringResource(key = "tab_sedarim", loader =
    stringsLoader)

private fun init_table_of_contents(): StringResource = StringResource(key = "table_of_contents",
    loader = stringsLoader)

private fun init_teamim(): StringResource = StringResource(key = "teamim", loader = stringsLoader)

private fun init_tehilim(): StringResource = StringResource(key = "tehilim", loader = stringsLoader)

private fun init_tehilim119(): StringResource = StringResource(key = "tehilim119", loader =
    stringsLoader)

private fun init_telegram_channel(): StringResource = StringResource(key = "telegram_channel",
    loader = stringsLoader)

private fun init_tell_a_friend(): StringResource = StringResource(key = "tell_a_friend", loader =
    stringsLoader)

private fun init_text_copy(): StringResource = StringResource(key = "text_copy", loader =
    stringsLoader)

private fun init_text_only_qri(): StringResource = StringResource(key = "text_only_qri", loader =
    stringsLoader)

private fun init_text_with_nikud(): StringResource = StringResource(key = "text_with_nikud", loader
    = stringsLoader)

private fun init_text_with_teamim(): StringResource = StringResource(key = "text_with_teamim",
    loader = stringsLoader)

private fun init_thanks_for_purchase(): StringResource = StringResource(key = "thanks_for_purchase",
    loader = stringsLoader)

private fun init_thanks_for_support(): StringResource = StringResource(key = "thanks_for_support",
    loader = stringsLoader)

private fun init_thanks_for_support_biblical(): StringResource = StringResource(key =
    "thanks_for_support_biblical", loader = stringsLoader)

private fun init_tikun_korim(): StringResource = StringResource(key = "tikun_korim", loader =
    stringsLoader)

private fun init_tiqun_haklali(): StringResource = StringResource(key = "tiqun_haklali", loader =
    stringsLoader)

private fun init_tiqun_haklali_ending(): StringResource = StringResource(key =
    "tiqun_haklali_ending", loader = stringsLoader)

private fun init_tiqun_haklali_intro(): StringResource = StringResource(key = "tiqun_haklali_intro",
    loader = stringsLoader)

public actual val SharedRes.strings.show_verse_letter: StringResource
  get() = CommonMainStrings11.show_verse_letter

public actual val SharedRes.strings.show_words_partially: StringResource
  get() = CommonMainStrings11.show_words_partially

public actual val SharedRes.strings.shuffle_verses: StringResource
  get() = CommonMainStrings11.shuffle_verses

public actual val SharedRes.strings.signs: StringResource
  get() = CommonMainStrings11.signs

public actual val SharedRes.strings.single_word: StringResource
  get() = CommonMainStrings11.single_word

public actual val SharedRes.strings.size_huge: StringResource
  get() = CommonMainStrings11.size_huge

public actual val SharedRes.strings.size_large: StringResource
  get() = CommonMainStrings11.size_large

public actual val SharedRes.strings.size_medium: StringResource
  get() = CommonMainStrings11.size_medium

public actual val SharedRes.strings.size_medium_value: StringResource
  get() = CommonMainStrings11.size_medium_value

public actual val SharedRes.strings.size_small: StringResource
  get() = CommonMainStrings11.size_small

public actual val SharedRes.strings.size_tiny: StringResource
  get() = CommonMainStrings11.size_tiny

public actual val SharedRes.strings.skip: StringResource
  get() = CommonMainStrings11.skip

public actual val SharedRes.strings.so_far_found: StringResource
  get() = CommonMainStrings11.so_far_found

public actual val SharedRes.strings.something_went_wrong: StringResource
  get() = CommonMainStrings11.something_went_wrong

public actual val SharedRes.strings.sort_results: StringResource
  get() = CommonMainStrings11.sort_results

public actual val SharedRes.strings.sortable: StringResource
  get() = CommonMainStrings11.sortable

public actual val SharedRes.strings.sounds: StringResource
  get() = CommonMainStrings11.sounds

public actual val SharedRes.strings.spaces_between_blanks: StringResource
  get() = CommonMainStrings11.spaces_between_blanks

public actual val SharedRes.strings.stats: StringResource
  get() = CommonMainStrings11.stats

public actual val SharedRes.strings.str_bookmark: StringResource
  get() = CommonMainStrings11.str_bookmark

public actual val SharedRes.strings.str_questions: StringResource
  get() = CommonMainStrings11.str_questions

public actual val SharedRes.strings.str_seconds: StringResource
  get() = CommonMainStrings11.str_seconds

public actual val SharedRes.strings.str_solution: StringResource
  get() = CommonMainStrings11.str_solution

public actual val SharedRes.strings.str_source: StringResource
  get() = CommonMainStrings11.str_source

public actual val SharedRes.strings.str_title: StringResource
  get() = CommonMainStrings11.str_title

public actual val SharedRes.strings.subscription: StringResource
  get() = CommonMainStrings11.subscription

public actual val SharedRes.strings.support_ad_dialog_content: StringResource
  get() = CommonMainStrings11.support_ad_dialog_content

public actual val SharedRes.strings.supporting_the_app: StringResource
  get() = CommonMainStrings11.supporting_the_app

public actual val SharedRes.strings.taanit_tzibur: StringResource
  get() = CommonMainStrings11.taanit_tzibur

public actual val SharedRes.strings.tab_bible: StringResource
  get() = CommonMainStrings11.tab_bible

public actual val SharedRes.strings.tab_chumash: StringResource
  get() = CommonMainStrings11.tab_chumash

public actual val SharedRes.strings.tab_misc: StringResource
  get() = CommonMainStrings11.tab_misc

public actual val SharedRes.strings.tab_sedarim: StringResource
  get() = CommonMainStrings11.tab_sedarim

public actual val SharedRes.strings.table_of_contents: StringResource
  get() = CommonMainStrings11.table_of_contents

public actual val SharedRes.strings.teamim: StringResource
  get() = CommonMainStrings11.teamim

public actual val SharedRes.strings.tehilim: StringResource
  get() = CommonMainStrings11.tehilim

public actual val SharedRes.strings.tehilim119: StringResource
  get() = CommonMainStrings11.tehilim119

public actual val SharedRes.strings.telegram_channel: StringResource
  get() = CommonMainStrings11.telegram_channel

public actual val SharedRes.strings.tell_a_friend: StringResource
  get() = CommonMainStrings11.tell_a_friend

public actual val SharedRes.strings.text_copy: StringResource
  get() = CommonMainStrings11.text_copy

public actual val SharedRes.strings.text_only_qri: StringResource
  get() = CommonMainStrings11.text_only_qri

public actual val SharedRes.strings.text_with_nikud: StringResource
  get() = CommonMainStrings11.text_with_nikud

public actual val SharedRes.strings.text_with_teamim: StringResource
  get() = CommonMainStrings11.text_with_teamim

public actual val SharedRes.strings.thanks_for_purchase: StringResource
  get() = CommonMainStrings11.thanks_for_purchase

public actual val SharedRes.strings.thanks_for_support: StringResource
  get() = CommonMainStrings11.thanks_for_support

public actual val SharedRes.strings.thanks_for_support_biblical: StringResource
  get() = CommonMainStrings11.thanks_for_support_biblical

public actual val SharedRes.strings.tikun_korim: StringResource
  get() = CommonMainStrings11.tikun_korim

public actual val SharedRes.strings.tiqun_haklali: StringResource
  get() = CommonMainStrings11.tiqun_haklali

public actual val SharedRes.strings.tiqun_haklali_ending: StringResource
  get() = CommonMainStrings11.tiqun_haklali_ending

public actual val SharedRes.strings.tiqun_haklali_intro: StringResource
  get() = CommonMainStrings11.tiqun_haklali_intro
